import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ArticalManagementService } from '../artical-management.service';

@Component({
  selector: 'app-modal-artical-preview',
  templateUrl: './modal-artical-preview.component.html',
  styleUrls: ['./modal-artical-preview.component.scss']
})
export class ModalArticalPreviewComponent implements OnInit {
  modalData;
  modalDataDetails;
  isLoading: boolean = false;
  dateAlwaysOpen: Date = new Date();
  isPollTime: boolean;
  profile;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalArticalPreviewComponent>,
    public matDialog: MatDialog,
    private articalManagementService: ArticalManagementService,
    private sanitizer: DomSanitizer
  ) {
    this.modalData = data;
    this.modalDataDetails = this.sanitizer.bypassSecurityTrustHtml(this.modalData.articalForm.articalContent);
    // console.log(this.modalData);
  }

  ngOnInit(): void {
    if (this.modalData.havePoll) {
      let timeNow = new Date();
      let pollEndDate = new Date(this.modalData.pollForm?.pollTime[1]);

      pollEndDate = new Date(new Date(pollEndDate.setDate(this.modalData.pollForm?.pollTime[1].getDate() + 1)).setHours(0, 0, 0));

      this.isPollTime = new Date(this.modalData.pollForm?.pollTime[0]) < timeNow && pollEndDate > timeNow;
    }
  }

  createArtical() {
    this.isLoading = true;

    this.articalManagementService.createArtical(this.modalData).subscribe((res) => {
      // console.log(res);

      if (res.success) {
        this.isLoading = false;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.id = 'modalConfirm';
        dialogConfig.width = '350px';
        dialogConfig.data = {
          title: 'สำเร็จ',
          description: '<img src="../../../assets/check.png" width="100px;" class="img-center">สร้างบทความสำเร็จแล้ว',
          cancleBtnText: 'ยืนยัน',
          customStyle: 'background-color: #58595B;'
        }

        const modal = this.matDialog.open(ModalComponent, dialogConfig);
        modal.afterClosed().subscribe(res => {
          if (!res) {
            window.opener.location.reload();
            setTimeout(() => {
              window.close()
            }, 100);
          }
        })
      }
    });
  }

  editArtical() {
    // // console.log(this.modalData);
    this.isLoading = true;
    this.articalManagementService.editArticalById(this.modalData).subscribe((res) => {
      // console.log(res);
      if (res.success) {
        this.isLoading = false;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.id = 'modalConfirm';
        dialogConfig.width = '350px';
        dialogConfig.data = {
          title: 'สำเร็จ',
          description: '<img src="../../../assets/check.png" width="100px;" class="img-center">แก้ไขบทความสำเร็จ',
          cancleBtnText: 'ยืนยัน',
          customStyle: 'background-color: #58595B;'
        }

        const modal = this.matDialog.open(ModalComponent, dialogConfig);
        modal.afterClosed().subscribe(res => {
          if (!res) {
            window.opener.location.reload();
            setTimeout(() => {
              window.close()
            }, 100);
          }
        })
      }
    });
  }
}
